import React, { useEffect, useRef, useState } from "react";
import { Toast } from "primereact/toast";
import Form from "../../components/Form/Form";
import { useFormConfig } from "./CourseCategoryFieldsConfig";
import { addCourseCategory } from "../../services/CourseCategoryService";
import { useLocation } from "react-router-dom";
import { updateCourse } from "../../services/CourseService";


function CourseCategoryForm({ onClose, onFormSubmit }) {
  const toast = useRef(null);
  const { courseCategoryForm } = useFormConfig();
  const location = useLocation();
  const { mode, courseCategory } = location.state || {};

  const [formData, setFormData] = useState(courseCategoryForm.initialFormData);

  useEffect(() => {
    if (mode === "update" && courseCategory) {
      setFormData({
        title: courseCategory.title || "",
        remarks: courseCategory.remarks || "",
      });
    } else {
      setFormData(courseCategoryForm.initialFormData);
    }
  }, [mode, courseCategory]);

  const handleSubmit = async (courseCategoryFormData) => {
    try {
      const response = mode === "update" && courseCategory
        ? await updateCourse(courseCategory.id, courseCategoryFormData)
        : await addCourseCategory(courseCategoryFormData);
      if (response.status === 200 || response.status === 201) {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: response.message || "Course Category Submitted Successfully",
          life: 1500,
        });
        setTimeout(() => {
          onClose();
          if (onFormSubmit) onFormSubmit();
        }, 1500);
      } else {
        throw new Error(response.message || "Something went wrong");
      }
    } catch (err) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: err.message || "Submission failed",
        life: 1500,
      });
    }
  };

  return (
    <>
    <Toast ref={toast} />
    <Form
      formTitle={courseCategoryForm.formTitle}
      initialFormData={formData}
      fieldConfig={courseCategoryForm.fieldConfig}
      onSubmit={handleSubmit}
      onClose={onClose}
      mode={mode}
    />
    </>
  );
}

export default CourseCategoryForm;
